export const CHANGE_CLIENT = 'CHANGE_CLIENT';
export const INITIALIZE = 'INITIALIZE';
export const LOGOUT = 'LOGOUT';

export const CASES_CHANGE_FILTER_DATES = 'CASES_CHANGE_FILTER_DATES';
export const CASES_CHANGE_FILTER_FULLTEXT_SEARCH = 'CASES_CHANGE_FULLTEXT_SEARCH';
export const CASES_CHANGE_FILTER_STATUSES = 'CASES_CHANGE_FILTER_STATUSES';
export const CASES_CHANGE_FILTER_SERVICES = 'CASES_CHANGE_FILTER_SERVICES';
export const CASES_CHANGE_FILTER_SPECIALISTS = 'CASES_CHANGE_FILTER_SPECIALISTS';
export const CASES_RESET_PAGE = 'CASES_RESET_PAGE';
export const CASES_RECEIVE = 'CASES_RECEIVE';
export const CASES_START_LOADER = 'CASES_START_LOADER';
export const CASES_STOP_LOADER = 'CASES_STOP_LOADER';

export const CREATE_CASE_SET_BACKEND_ERRORS = 'CREATE_CASE_SET_BACKEND_ERRORS';
export const CREATE_CASE_SET_PROGRESS = 'CREATE_CASE_SET_PROGRESS';
export const CCCO_FILL_MATERIALS_FORM = 'CCCO_FILL_MATERIALS_FORM';

export const CCOF_CHANGE_FORM_VALID = 'CCOF_CHANGE_FORM_VALID';
export const CCOF_CHANGE_FORM_FIELD = 'CCOF_CHANGE_FORM_FIELD';
export const CCOF_ADD_SERVICE = 'CCOF_ADD_SERVICE';
export const CCOF_REMOVE_SERVICE = 'CCOF_REMOVE_SERVICE';
export const CCOF_CHANGE_SERVICE_QUANTITY = 'CCOF_CHANGE_SERVICE_QUANTITY';
export const CCOF_CREATE_MATERIAL = 'CCOF_CREATE_MATERIAL';
export const CCOF_DELETE_MATERIAL = 'CCOF_DELETE_MATERIAL';
export const CCOF_RESET_FORM = 'CCOF_RESET_FORM';
export const CCOF_UPDATE_FILES = 'CCOF_CASE_UPDATE_FILES';

export const UCCO_INIT = 'UCCO_INIT';
export const UCCO_SET_BACKEND_ERRORS = 'UCCO_SET_BACKEND_ERRORS';
export const UCCO_FILL_MATERIALS_FORM = 'UCCO_FILL_MATERIALS_FORM';

export const CASE_CREATION_ORDERS_CHANGE_FILTER_STATUSES = 'CASE_CREATION_ORDERS_CHANGE_FILTER_STATUSES';
export const CASE_CREATION_ORDERS_CHANGE_FILTER_DATES = 'CASE_CREATION_ORDERS_CHANGE_FILTER_DATES';
export const CASE_CREATION_ORDERS_RESET_PAGE = 'CASE_CREATION_ORDERS_RESET_PAGE';
export const CASE_CREATION_ORDERS_RECEIVE_ORDERS = 'CASE_CREATION_ORDERS_RECEIVE_ORDERS';
export const CASE_CREATION_ORDERS_RECEIVE_ORDER = 'CASE_CREATION_ORDERS_RECEIVE_ORDER';
export const CASE_CREATION_ORDERS_CHANGE_LOADER = 'CASE_CREATION_ORDERS_CHANGE_LOADER';
export const CASE_CREATION_ORDERS_CHANGE_LOADER_BY_ORDERS = 'CASE_CREATION_ORDERS_CHANGE_LOADER_BY_ORDERS';
export const CASE_CREATION_ORDERS_CHANGE_SCANNING = 'CASE_CREATION_ORDERS_CHANGE_SCANNING'

export const FETCH_DP_URL = 'FETCH_DP_URL'
